// extracted by mini-css-extract-plugin
export default {"content":"DocumentList_content__q6Ftt","gridView":"DocumentList_gridView__7X58W","listView":"DocumentList_listView__5NLyu"};